import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_005",
  "use": "icon-su_005-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-su_005\"><defs><style>#icon-su_005 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-su_005_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_005_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"20.71 4.71 19.29 3.29 12 10.59 4.71 3.29 3.29 4.71 10.59 12 3.29 19.29 4.71 20.71 12 13.41 19.29 20.71 20.71 19.29 13.41 12 20.71 4.71\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol